import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import NB from './NB';
const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const NotebookLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#Notebook') {
      setBackI(appColors['ColorE']);
      setBackII('transparent');
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#Notebook' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorE'], fontSize: '3vh'}}>Notebook</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorE'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> N&nbsp;<br/> O&nbsp;<br/> T&nbsp;<br/> E&nbsp;<br/> B&nbsp;<br/> O&nbsp;<br/> O&nbsp;<br/> K&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='Notebook'>
              <NB/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default NotebookLogic;
